import { useTypingState } from "@/zustand/TypingState";
import { TypingEventType } from "./types";

/**
 * Normalize a possibly non-boolean `is_typing` into a real boolean. The broker
 * contract is a JSON boolean, but be defensive: a plain `Boolean()` would turn
 * the string "false" (or "0") into `true`, flipping a stop into a start. Treat
 * the explicit falsy string/number forms as false; everything else follows
 * normal truthiness.
 */
const normalizeIsTyping = (value: unknown): boolean => {
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    if (v === "false" || v === "0" || v === "") {
      return false;
    }
    return true;
  }
  return Boolean(value);
};

/**
 * Handles inbound `typing` broadcasts from the broker and folds them into the
 * ephemeral typing store. The broker contract is { chat_id, username, is_typing }.
 *
 * No filtering of self is done here — the render-time resolver
 * (resolveTypingLabel) excludes the current user. Keeping the handler dumb means
 * the store is a faithful mirror of the wire and stays trivially testable.
 */
export const handleTypingEvent = (data: TypingEventType): void => {
  if (!data?.chat_id || !data?.username) {
    return;
  }
  useTypingState
    .getState()
    .setTyping(data.chat_id, data.username, normalizeIsTyping(data.is_typing));
};
